/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionExtractionResponseDto } from '../../models/submission-extraction-response-dto';

export interface ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Params {
  submissionId: string;
  documentId: string;
}

export function apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet(http: HttpClient, rootUrl: string, params: ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionExtractionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet.PATH, 'get');
  if (params) {
    rb.path('submissionId', params.submissionId, {});
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionExtractionResponseDto>;
    })
  );
}

apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet.PATH = '/api/idp/submissions-direct/submission-extraction/{submissionId}/{documentId}';
